<template>
    <validation-observer ref="plusMinusForm">
        <div>
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <div class="plus-minus-attribute">
                    <label  :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}">
                        {{ this.question.question_text }}
                    </label>
                    <validation-provider :rules="question.mandatory ? 'required' : ''" v-slot="{errors}">
                        <div  :class="{' col-md-9 col-xs-8  ' : isInquiry}">

                            <div class="input-group">
                            <span class="input-group-btn input-group-prepend">
                                <button class="btn btn-outline bootstrap-touchspin-down minus-btn" @click="minus" type="button">-</button>
                            </span>
                                <input type="number" :name="name" :id="id" v-model="question.value" ref="input"
                                       class="text-center form-control" @change="updateData">
                                <input type="hidden" :value="id" name="questions[]">

                                <!--                    <span class="input-group-addon bootstrap-touchspin-postfix input-group-append"-->
                                <!--                          v-if="attribute.title !== ''">-->

                                <span class="input-group-btn input-group-append">
                        <button class="btn btn-outline bootstrap-touchspin-up plus-btn" @click="plus"
                                type="button">+</button>
                    </span>
                            </div>
                            <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                            <span class="text text-danger error-label" v-if="errors && errors.length">{{ errors[0] }}</span>
                        </div>
                    </validation-provider>
                </div>
            </div>
        </div>
    </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormPlusMinus",
    props: {
        value: {
            type: Object,
            default() {
                return {}
            }
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question: {
                ...this.value,
                value: this.value.answer_text_names ? parseInt(this.value.answer_text_names, 10) : 0
            },
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        updateData(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry( this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },
        addEventListeners() {

            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                    if(this.$refs.plusMinusForm) {
                        let validated = await this.$refs.plusMinusForm.validate();
                        verify(validated)
                    }
            })


        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        /**
         * pick a value
         * @param value
         */
        onChange(event) {
            let value = event.target.value

            this.question.value = value

            this.$emit('input', this.question.value);
        },
        minus() {
            if( this.question.value != 0){
                this.question.value--;
                this.$emit('input', this.question)
            }
            this.updateData()
        },
        plus() {
            this.question.value++
            this.updateData()
            // this.$emit('input', this.question)
            // this.$emit('input', this.question.value)
        },
        triggerChange() {
            // EventBus.$emit('onServiceCustomFieldSelected',this.attribute.service_id,this.clone)
        },
        removeObjectWithId(arr, id) {
            const found = arr.filter(element => element.attribute_id == id);
            const count = arr.filter(element => element.attribute_id == id).length;
            arr.splice(found, count);
        }
    },
    watch: {
        question: {
            handler: function (question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    mounted() {
        if (!this.question.value) {
            this.question.value = 0;
        }
        this.addEventListeners()
    },
    destroyed() {
        this.removeEventListeners()
    }

}
</script>

<style scoped>
@media (max-width: 768px) {
    .input-group-addon {
        padding: 0px !important;
        white-space: break-spaces;
    }
}

.p-0-1{
    padding:0px 1px;
}


@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        /*margin-left: 17px !important;*/
    }
}

@media screen and (min-width: 1px) and (max-width: 428px) {
    .change-form-list-in-inquiry {
        width: 66%;
        /*margin-left: 15px !important;*/
    }
}
@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        /*margin-left: 15px !important;*/
    }
    .change-form-list-in-inquiry  .form-control{
        width: 100% !important;
    }
}

</style>